<template>
  <div class="form-group pt-0 closed-caption-upload-wrapper file-upload-vue-wrapper">
    <div class="form-group-beside row no-gutters" :class="underlineFieldClass">
      <div class="col-2 col-md-6">
        <label class="closed-caption-label entry-field__label" for="closed_caption">{{ display_name }} <em class="yellow no-style" v-if="required == 1">*</em></label>
        <div class="description" v-html="description"></div>
      </div>
      <div class="col-10 col-md-6 pl-3">
        <a href="#" class="btn btn-primary displaybloc" @click.prevent="activateDropzone(machine_name)" v-if="update_allowed && filename == ''"><upload class="svg-24 svg-black"></upload> Upload</a>
        <div class="input-wrapper" v-show="update_allowed && filename == '' && showDropzone">
          <vue-dropzone class="video-placeholder" ref="myVueDropzone" :id="'dropzone'+machine_name" :options="dropzoneOptions" v-on:vdropzone-success="successCallback" v-on:vdropzone-file-added="acceptCallback"></vue-dropzone>

        </div>
        <div id="closed_caption" class="pr-3 form-control-left-border form-control filename no-border d-flex justify-content-between align-items-center">
          <span class="cc-filename">{{ filename }}</span>
          <div class="d-flex align-items-center">
            <a :href="view_url" v-if="view_url && ['marketing', 'admin', 'viewer', 'bricker'].includes(role)" class="btn btn-primary mr-2" target="_blank" download>Download</a>
            <a :href="view_url" v-if="view_url" class="btn btn-primary" target="_blank">View</a>
            <span class="cc-filename-trash ml-2 cursor-pointer p-2" @click.prevent="activateDeleteCCFilePopup()" v-if="filename != '' && update_allowed"><trash class="svg-24"></trash></span>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
      <h3 slot="header">Removing Video File</h3>
      <div class="content" slot="body">
        <div>Are you sure you want to remove from this order? </div>
      </div>
      <div class="form-group-submit clearfix" slot="footer">
        <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmDelete = false">Cancel</button>
        <button class="pull-right" @click.prevent="deleteVideo()">Yes, Remove</button>
      </div>
    </modal>

  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import AWS from 'aws-sdk/global';
import S3 from 'aws-sdk/clients/s3';
import modal from './Modal.vue';
import upload from './icons/upload.vue';
import trash from './icons/trash.vue';

export default {
  components: { modal, vueDropzone, upload, trash },
  props: ['entry', 'file_types', 'saved_filename', 'description', 'display_name', 'required', 'machine_name', 'view_url', 'update_allowed', 'role'],
  data() {
    return {
      filename: this.saved_filename,
      modalTriggerConfirmDelete: false,
      showDropzone: false,
      underlineFieldClass: '',
      dropzoneOptions: {
        url: '/entry/' + this.entry.id,
        thumbnailWidth: 150,
        paramName: this.machine_name,
        acceptedFiles: this.file_types,
        maxFilesize: 30000, // 30GB
        timeout: 86400000, // 24hrs
        headers: { 'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content },
        error: function(file, message) {
          let errorMessage = message + ' There was a problem uploading your file.';
          this.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
          this.$scrollTo('#top-of-form', 700);
        }.bind(this)
      }
    }
  },
  methods: {
    activateDropzone: function(machine_name) {
      $('#dropzone' + machine_name).click();
    },
    activateDeleteCCFilePopup: function() {
      let app = this;
      app.modalTriggerConfirmDelete = true;
    },
    deleteVideo: function() {
      let app = this;
      let actionUrl = `/entry/` + app.entry.id;
      window.axios(
          {
            method: 'POST',
            data: {
              [app.machine_name]: '',
            },
            url: actionUrl,
          }).then(function(response) {
        app.filename = '';
        app.modalTriggerConfirmDelete = false;
        window.location.reload();
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error. There was a problem deleting your file.';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    underlineFields() {
      let app = this;
      let submitFormBlock = true;
      // If required and filename is blank, don't submit the form!
      if((app.required == 1) && (app.filename == '')) {
        submitFormBlock = false;
        app.underlineFieldClass = ' required';
      }
      return submitFormBlock;
    },
    successCallback: function(file, response) {
      this.filename = file.upload.filename;
      this.underlineFieldClass = '';
    },
    acceptCallback: function(file, dzone) {
      this.showDropzone = true;
    }
  }
}
</script>
